import React from "react";
import { Link } from "react-router-dom";

// Image \\
import hoverImg from "../../assets/images/hoverIcon.svg";
import doctors_Avatar from "../../assets/images/doctorsAvatar.svg";

// Style \\
import "../../assets/styles/cards/serviceCard.scss";

//  Icons \\
import { FaArrowRight } from "react-icons/fa6";

const ServicesCard = (props) => {
  const newData = props.data;

  return (
    <div>
      <div className="cardServices">
        <div className="cardServices_items">
          <div className="cardServices_items_image">
            <img
              className="serviceAvatar"
              src={newData.img}
              alt="serviceAvatar"
            />
          </div>

          <div className="cardService_items_text">
            <div className="title">
              <h3>{newData.field}</h3>
            </div>
            <div className="desc">
              <p>{newData.desc}</p>
            </div>

            <div className="link_box">
              <Link
                to={{
                  pathname: `/service/${newData.id}`,
                  state: { newData },
                }}
                className="Link"
              >
                Learn More <FaArrowRight className="icons" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesCard;
